import { useLocation } from "wouter";
import { Plus, Search, BarChart3 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { ProjectStats } from "@/components/project/project-stats";
import { ProjectList } from "@/components/project/project-list";
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileDashboard } from "./mobile/mobile-dashboard";

export default function DashboardPage() {
  const [, navigate] = useLocation();
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileDashboard />;
  }

  const actionCards = [
    {
      icon: Plus,
      title: "Neues Projekt",
      description: "Neue Erfassung starten",
      onClick: () => navigate("/project/create"),
    },
    {
      icon: Search,
      title: "Projekte suchen",
      description: "Bestehende Projekte finden",
      onClick: () => navigate("/search"),
    },
    {
      icon: BarChart3,
      title: "Statistiken",
      description: "Auswertungen ansehen",
      onClick: () => alert("Statistiken werden implementiert..."),
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
          <h1 className="text-4xl font-bold text-bauwerk-teal mb-2">Dashboard</h1>
          <p className="text-gray-600">Übersicht Ihrer Projekte und Aktivitäten</p>
      </div>

      <ProjectStats />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {actionCards.map((card) => (
            <Card
              key={card.title}
              className="cursor-pointer hover:shadow-lg hover:-translate-y-1 transition-all duration-200"
              onClick={card.onClick}
            >
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-bauwerk-teal rounded-full flex items-center justify-center mb-4">
                  <card.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-bauwerk-teal mb-2">
                  {card.title}
                </h3>
                <p className="text-gray-600 text-sm">{card.description}</p>
              </CardContent>
            </Card>
          ))}
      </div>

      <ProjectList />
    </div>
  );
}
